// extracted by mini-css-extract-plugin
export var container = "_1n-0";
export var disabled = "_1n-4";
export var fullWidth = "_1n-3";
export var lined = "_1n-1";
export var selected = "_1n-5";
export var tab = "_1n-2";